import axios from "../../config/axios";

export const getAllNews = body =>
  axios.get(`news?limit=${body.limit}&offset=${body.offset}`);



// WEBPACK FOOTER //
// ./src/services/requestors/news.js